export default "__VITE_ASSET__D$BsQJFM__"